import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

import { useStore } from "vuex";
import { watch } from "vue";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const store = useStore();
let router = useRouter();

const routes = JSON.parse(localStorage.getItem("routes")!);

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": _unref(router).currentRoute.value.path,
    class: "el-menu-vertical-demo",
    collapse: _unref(store).state.isCollapse,
    router: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.path
        }, [
          (item.children)
            ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: 0,
                index: item.path
              }, {
                title: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (ii) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: ii.path
                    }, [
                      (!ii.children)
                        ? (_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 0,
                            index: ii.path
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(ii.meta.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                        : (_openBlock(), _createBlock(_component_el_sub_menu, {
                            key: 1,
                            index: ii.path
                          }, {
                            title: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent(ii.meta.icon)))
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("span", null, _toDisplayString(ii.meta.title), 1)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ii.children, (iii) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: iii.path
                                }, [
                                  (!iii.children)
                                    ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                        key: 0,
                                        index: iii.path
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(iii.meta.title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["index"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["index"]))
                    ], 64))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["index"]))
            : (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 1,
                index: item.path
              }, {
                title: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.meta.title), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["index"]))
        ], 64))
      }), 128))
    ]),
    _: 1
  }, 8, ["default-active", "collapse"]))
}
}

})